import serializeParam from './serializeParam'

/**
 * ajax请求对象
 * @param  {Object} option 请求参数
 * @param  {Function} option.success 成功回调（cgi返回了2xx状态码）
 * @param  {Function} option.error 失败回调。（包含网络错误，没有跨域头，cgi返回非2xx状态码等情况）
 * @param  {Int} option.timeout 超时时间。
 * @param  {Int} option.onTimeout 超时回调
 * @param  {Function} option.complete 无论成功还是失败都会回调
 * @return {XMLHttpRequest} xhr
 */
export default function(option) {
    var o = option;
    var m = o.method.toLocaleUpperCase();
    var isPost = 'POST' == m;

    var xhr = new XMLHttpRequest();

    var qstr = serializeParam(o.param);

    // get 请求 参数处理
    qstr && !isPost && (o.url += (o.url.indexOf('?') > -1 ? '&' : '?' ) + qstr );

    xhr.open(m, o.url, true);
    qstr && isPost && xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function () {
        var status = xhr.status;
        if (status >= 200 && status < 300) {
            var result;
            try {
                result = eval('(' + xhr.responseText + ')')
            } catch (e) {
            }
            o.success && o.success.call(xhr, result);
        } else {
            o.error && o.error.call(xhr, xhr);
        }
        o.complete && o.complete.call(xhr, xhr);
    };
    
    xhr.onabort = xhr.onerror = function(){
    	o.error && o.error.call(xhr, xhr);
    	o.complete && o.complete.call(xhr, xhr);
    }
    
    if (o.timeout) {
        xhr.timeout = o.timeout
        xhr.ontimeout = function () {
            o.onTimeout && o.onTimeout.call(xhr, xhr);
            o.complete && o.complete.call(xhr, xhr);
        }
    }

    xhr.send(isPost ? qstr || o.body : void (0));

    return xhr;
}